module.exports = __webpack_public_path__ + "static/img/feedback.165ff8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icons/feedback.png
// module id = 708
// module chunks = 6